<footer class="footer">
  <div class="footer__bg">
    <div class="footer__container container grid">
      <div>
        <h1 class="footer__title">Giovanni</h1>
        <span class="footer__subtitle">Frontend developer</span>
      </div>

      <ul class="footer__links">
        <li>
          <a href="#qualification" class="footer__link">Qualification</a>
        </li>
        <li>
          <a href="#portfolio" class="footer__link">Portfolio</a>
        </li>
        <li>
          <a href="#contact" class="footer__link">Contact Me</a>
        </li>
      </ul>

      <div class="footer__socials">
        <a href="https://facebook.com" target="_blank" class="footer__social">
          <i class="uil uil-facebook-f"></i>
        </a>
        <a href="https:://instagram.com" target="_blank" class="footer__social">
          <i class="uil uil-instagram"></i>
        </a>
        <a href="https://twitter.com" target="_blank" class="footer__social">
          <i class="uil uil-twitter-alt"></i>
        </a>
      </div>
    </div>

    <p class="footer__copy">&#169; GiovannIzzi. All right reserved 2021</p>
  </div>
</footer>

<a href="#home" class="scrollup" [ngClass]="{'show-scroll': showScroll === true}" (scroll)="onScroll($event)">
  <i class="uil uil-arrow-up scrollup__icon"></i>
</a>
